<template>
  <div class="component">
    <h1 class="component__title">Our Pricing</h1>
    <div class="component__box">
      <div><span>Anually</span></div>
      <label class="switch-wrap">
        <input @click="btnToggling" type="checkbox" />
        <div class="switch"></div>
      </label>
      <div><span>Monthly</span></div>
    </div>
    <div v-for="plan in plans" :key="plan.title">
      <PlanCard
        :title="plan.title"
        :price="plan.price"
        :storage="plan.storage"
        :users="plan.users"
        :transfer="plan.transfer"
        :pricing="pricingAnually"
        :currentPlan="selectedPlan"
        @select="selectPlan"
      />
    </div>
  </div>
</template>

<script>
import PlanCard from "./components/PlanCard.vue";

export default {
  name: "App",
  data() {
    return {
      pricingAnually: "true",
      plans: {
        basic: {
          title: "Basic",
          price: {
            anually: 19.99,
            monthly: 199.99,
          },
          storage: "500 GB",
          users: 2,
          transfer: "3 GB",
        },
        professional: {
          title: "Professional",
          price: {
            anually: 24.99,
            monthly: 249.99,
          },
          storage: "1 TB",
          users: 5,
          transfer: "10 GB",
        },
        master: {
          title: "Master",
          price: {
            anually: 39.99,
            monthly: 399.99,
          },
          storage: "2 TB",
          users: 10,
          transfer: "20 GB",
        },
      },
      selectedPlan: "Professional",
    };
  },
  methods: {
    btnToggling() {
      this.pricingAnually = !this.pricingAnually;
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
    },
  },
  components: {
    PlanCard,
  },
};
</script>
